export default "__VITE_ASSET__YIbzE4NA__"